import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Checks whether Quick Compose should display multiple pivots
 * Pivots should be shown when the form is not in edit mode and any tab content, other than Event, is enabled
 */
export default function shouldShowPivots(isEditMode: boolean): boolean {
    // At the moment, the only other pivot we have is for Automatic Replies.
    // We should add to this logic when we want to enable new pivots.
    return !isEditMode && isFeatureEnabled('cal-multiOOF-quickCompose');
}
